module.exports = "/assets/data/edfbd37a87480d0941006d41e35ff84b-KA15.data.json";